import {AxiosInstance, AxiosResponse} from 'axios';
//api
import {orgAPI} from '@/core/api';
//types
import {
  IOrganizationTablesAndTicketsRequest,
  IOrganizationTableNumberUpdateRequest,
  IOrganizationTableTicketsResponse,
  IOrganizationTablesAndTicketsAvailableResponse,
  IOrganizationTicketsListResponse,
  IOrganizationTicketsStatistics,
  IOrganizationTicketsTiers,
  IRequestWithPagination,
  IOrganizationTableTicketsRequest,
  ITableAndTicketStripeRes,
} from '@/utils/types';
//enum
import {API_URL} from '../enums/api-url.enum';

class OrganizationTableAndTicketsService {
  static getTicketsList = async (
    reqBody: IRequestWithPagination,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationTicketsListResponse>> =>
    apiInstance.post(API_URL.TABLES_AND_TICKETS_TICKETS_LIST, reqBody);

  static getTicketsTiers = async (
    eventId: number,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationTicketsTiers[]>> =>
    apiInstance.get(`${API_URL.TABLES_AND_TICKETS_TIERS}/${eventId}`);

  static updateTableNumber = async (reqBody: IOrganizationTableNumberUpdateRequest, apiInstance: AxiosInstance): Promise<AxiosResponse> =>
    apiInstance.put(`${API_URL.TABLES_AND_TICKETS}/${reqBody.id}/number`, {number: +reqBody.number});

  static getTicketsStatistics = async (eventId: number): Promise<AxiosResponse<IOrganizationTicketsStatistics>> =>
    orgAPI.get(`${API_URL.TABLES_AND_TICKETS_STATISTICS}/${eventId}`);

  static createTableAndTickets = async (
    reqBody: IOrganizationTablesAndTicketsRequest,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse> => apiInstance.post(API_URL.TABLES_AND_TICKETS, reqBody);

  static getTableAndTicketsAvailable = async (
    reqBody: IRequestWithPagination
  ): Promise<AxiosResponse<IOrganizationTablesAndTicketsAvailableResponse>> =>
    orgAPI.post(API_URL.TABLES_AND_TICKETS_AVAILABLE_TICKETS, reqBody);

  static getTableAndTicketsAvailableCsv = async (id: number): Promise<AxiosResponse<File>> =>
    orgAPI.get(`${API_URL.TABLES_AND_TICKETS_AVAILABLE_TICKETS_EXPORT}/${id}`);

  static deleteTableAndTickets = async (tableId: number): Promise<AxiosResponse> =>
    orgAPI.delete(`${API_URL.TABLES_AND_TICKETS_TABLE}/${tableId}`);

  static getTableTickets = async (
    tableId: number,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationTableTicketsResponse>> =>
    apiInstance.get(`${API_URL.TABLES_AND_TICKETS_TABLE}/${tableId}`);

  static updateTableTickets = async (
    tableId: number,
    reqBody: IOrganizationTableTicketsRequest,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationTableTicketsResponse>> =>
    apiInstance.put(`${API_URL.TABLES_AND_TICKETS_TABLE}/${tableId}`, reqBody);

  static updateTicketStatus = async (reqBody: {
    tableId: number;
    isPaid: boolean;
  }): Promise<AxiosResponse<IOrganizationTableTicketsResponse>> =>
    orgAPI.put(`${API_URL.TABLES_AND_TICKET_UPDATE_STATUS}/${reqBody.tableId}?isPaid=${reqBody.isPaid}`);

  static prepareStripeSessionForTickets = async (
    reqBody: IOrganizationTablesAndTicketsRequest,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<ITableAndTicketStripeRes>> =>
    apiInstance.post(`${API_URL.TABLES_AND_TICKET_PREPARE_CHECKOUT}`, reqBody);

  static getTicketsTiersByPrivateLink = async (
    eventId: number,
    privatePurchaseToken: string,
    apiInstance: AxiosInstance
  ): Promise<AxiosResponse<IOrganizationTicketsTiers[]>> =>
    apiInstance.get(`${API_URL.TABLES_AND_TICKETS_TIERS}/${eventId}?privatePurchaseToken=${privatePurchaseToken}`);

}

export {OrganizationTableAndTicketsService};
